module.exports = __webpack_public_path__ + "img/proyecto_9_mv.5c813816.webp";